<app-trip-type-setup-header
  [vehicleType]="selectedVehicleType"></app-trip-type-setup-header>
<dv-dynamic-form
  class="vehicle-trip-type-setup-form"
  [elements]="setupElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>

<app-trip-type-setup-grid
  class="vehicle-trip-type-setup-grid"
  [rowData]="setupGridData()"
  [hasEditPermission]="canEditGrid"
  [hasDeletePermission]="canDeleteGrid"
  [entityName]="vehicleTripTypeSetupEntityName"
  [noRowsMessageKey]="noRowsMessageKey()"
  (hasGridDataChanged)="onGridDataChanged($event)"
  (gridReloadClick)="onGridReloadClick()"></app-trip-type-setup-grid>

<dv-save-panel
  labelCancel=""
  labelSave="{{ 'General.Save' | translate }}"
  [disableSave]="isSaveDisabled()"
  (save)="onSave()">
</dv-save-panel>
